module.exports = __webpack_public_path__ + "img/cereal.3f04cdcd.jpg";